import { render } from "./ColorSelection.vue?vue&type=template&id=75348264&scoped=true&ts=true"
import script from "./ColorSelection.vue?vue&type=script&lang=ts"
export * from "./ColorSelection.vue?vue&type=script&lang=ts"

import "./ColorSelection.vue?vue&type=style&index=0&id=75348264&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75348264"]])

export default __exports__